import styled from "styled-components";
import Icon from "./Icon";

const Tile = styled.div`
  background-color: ${props => props.theme.tileColor};
  border-radius: 10px;
  box-shadow: ${props => props.theme.tileShadow};
  display: flex;
  justify-content: center;
  align-items: center;

  & * {
    height: 60%;
    width: 60%;
  }

  &.hidden * {
    opacity: 0;
  }

  &.matched,
  .matched * {
    background-color: transparent;
  }

  &.opened,
  .opened * {
    background-color: ${props => props.theme.openColor};
  }
`;

export default function Tiles({ click, state, svgNo, index }) {
  return (
    <Tile className={"Tiles " + state} onClick={() => click(svgNo, index)}>
      <Icon svgNo={svgNo} />
    </Tile>
  );
}
